import WebViewType from "./enums/WebViewType";

class WebViewResponseItem {
  constructor(public id: number, public name: string) {}
}

class WebViewDTO {
  constructor(
    public webViewType: WebViewType,
    public windowTitle: string,
    public selectedItemsIDs: number[],
    public selectedItemsInfo: WebViewResponseItem[]
  ) {}
}

export { WebViewDTO, WebViewResponseItem };
